import {
  Button,
  Checkbox,
  CircularProgress,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  MenuItem,
  Paper,
  Typography,
} from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import MaskedInput from "react-text-mask";
import step1 from "../../../assets/images/find_location/step1.png";
import step2 from "../../../assets/images/find_location/step2.png";
import step3 from "../../../assets/images/find_location/step3.png";
import step4 from "../../../assets/images/find_location/step4.png";
import { alert } from "../../../components/AlertDialog";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import {
  StyledToggleButton,
  StyledToggleButtonGroup,
} from "../../../components/CustomStyles/CustomToggleButton";
import CustomizedDialogs from "../../../components/FormDialog/FormDialog";
import InputImage from "../../../components/InputImage";
import InputSelectSearch from "../../../components/InputSelectSearch";
import {
  createMaskInput,
  formatCurrency,
  formatDB,
  getCurrencySymbols,
} from "../../../components/Utils/Currency";
import PropertyService from "../../../Services/PropertyService";
import propertyStore from "../../../Store/PropertyStore";

const styles = (theme) => ({
  header: {
    textAlign: "center",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
});

const Instruction = (props) => {
  const { classes, width } = props;
  const [openDialog, setOpenDialog] = React.useState(true);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <CustomizedDialogs
      disableBackdropClick
      maxWidth={width !== "xs" ? "md" : false}
      fullScreen={width === "xs"}
      title={props.title}
      scroll="body"
      open={openDialog}
      handleClose={handleCloseDialog}
    >
      <DialogContent classes={{ root: classes.content }} dividers>
        <Paper className={classes.root} style={{ boxShadow: "none" }}>
          <Grid container>
            <Grid item xs={12}>
              <Typography
                variant="subtitle1"
                style={{ fontWeight: "bolder", fontSize: 18 }}
                gutterBottom
              >
                How to find a location's Latitude &amp; Longitude in Google Maps
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <p style={{ fontSize: 13, color: "#757575" }}>
                1. Navigate to Google's Maps website:{" "}
                <a
                  href="https://maps.google.com"
                  target="_blank"
                  style={{ color: "#2196F3" }}
                >
                  www.google.com/maps
                </a>
                <br />
                <img
                  src={step1}
                  alt="google maps"
                  style={{
                    width: "100%",
                    height: "auto",
                    marginBottom: "12px",
                  }}
                />
                <br />
                2. Enter the address you want to find the Latitude &amp;
                Longitude for such as <strong>ClubRunner</strong>
                <br />
                <img
                  src={step2}
                  alt="google maps"
                  style={{
                    width: "100%",
                    height: "auto",
                    marginBottom: "12px",
                  }}
                />
                <br />
                3. Right click on the Map's pin point, and from the new menu
                choose What's Here?
                <br />
                <img
                  src={step3}
                  alt="google maps"
                  style={{
                    width: "100%",
                    height: "auto",
                    marginBottom: "12px",
                  }}
                />
                <br />
                4. A box at the bottom of the page will appear with the decimal
                degrees coordinates that are required for ClubRunner. Latitude
                is the first value, and Longitude is the second value.
                <br />
                <img
                  src={step4}
                  alt="google maps"
                  style={{
                    width: "100%",
                    height: "auto",
                    marginBottom: "12px",
                  }}
                />
                <br />
              </p>
            </Grid>
          </Grid>
        </Paper>
      </DialogContent>
    </CustomizedDialogs>
  );
};

Instruction.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
function showInstruction(options = {}) {
  return createConfirmation(
    confirmable(withStyles(styles)(withWidth()(Instruction)))
  )({
    ...options,
  });
}

function Form(props) {
  const user = JSON.parse(localStorage.getItem("user")) || "";
  const {
    classes,
    width,
    title,
    data,
    cancel,
    handleGetPropertyList,
    handleUpdateData,
  } = props;
  const [openDialog, setOpenDialog] = React.useState(true);
  const [optionsParent, setOptionsParent] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [propertyState, propertyActions] = propertyStore();
  const [feeType, setFeeType] = React.useState("percent");
  const [state, setState] = React.useState({
    formData: {
      about: "",
      address: "",
      email: "",
      currency: process.env.REACT_APP_CURRENCY_CODE,
      id: "",
      image_banner_url: "",
      initial: "",
      latitude: "",
      level: 1,
      logo: {
        square: "",
        rectangle: "",
      },
      longitude: "",
      name: "",
      phone: "",
      timezone: "",
      type: "",
      website_url: "",
      fee: {
        name: "",
        amount: "",
        percent: "",
      },
      have_runner: false,
      parent: {
        id: user?.operational?.level === 2 ? user?.operational?.id : 0,
      },
    },
  });
  // const [optionsCurrency, setOptionsCurrency] = React.useState([]);

  const handleCloseDialog = () => {
    setState({
      formData: {
        about: "",
        address: "",
        email: "",
        currency: process.env.REACT_APP_CURRENCY_CODE,
        id: "",
        image_banner_url: "",
        initial: "",
        latitude: "",
        level: 1,
        logo: {
          square: "",
          rectangle: "",
        },
        longitude: "",
        name: "",
        phone: "",
        timezone: "",
        type: "",
        website_url: "",
        fee: {
          name: "",
          amount: "",
          percent: "",
        },
        have_runner: false,
        parent: {
          id: user?.operational?.level === 2 ? user?.operational?.id : 0,
        },
      },
    });
    setOpenDialog(false);
  };

  const handleShowInstruction = () => {
    showInstruction().then(
      (process) => {
        // handleActions(value);
      },
      (cancel) => {
        // setUpdate(!update);
      }
    );
  };

  const asyncGetOptionsParent = (query) => {
    return new Promise((resolve, reject) => {
      PropertyService.getList({
        type: "brand",
        keyword: query,
        cursor: "",
      })
        .then((response) => {
          const listOptions = response.data.map((row) => ({
            value: row.id,
            name: row.name,
          }));
          setOptionsParent(listOptions);
          resolve(listOptions);
        })
        .catch(reject);
    });
  };

  const handleSubmit = (event) => {
    if (
      state.formData.image_banner_url === "" ||
      state.formData.logo.square === "" ||
      state.formData.logo.rectangle === ""
    ) {
      const arrError = [];

      if (state.formData.image_banner_url === "") {
        arrError.push("Property Banner");
      }

      if (state.formData.logo.square === "") {
        arrError.push("Property Logo (Square)");
      }

      if (state.formData.logo.rectangle === "") {
        arrError.push("Property Logo (Rectangle)");
      }

      const txtError = arrError.length > 1 ? arrError.join(", ") : arrError[0];

      alert("Warning", `Please upload ${txtError}`);
    } else {
      confirm("Submit", "Are you sure to Submit ?").then(async (onProcess) => {
        if (props.data === null) {
          const { formData } = state;
          formData.fee.percent =
            formData.fee.percent !== ""
              ? parseFloat(formatDB(formData.fee.percent.replace("%", "")))
              : 0;
          formData.fee.amount =
            formData.fee.amount !== ""
              ? parseFloat(
                  formatDB(
                    formData.fee.amount.replace(
                      process.env.REACT_APP_CURRENCY_SYMBOL,
                      ""
                    )
                  )
                )
              : 0;
          formData.level =
            formData.type === "group" ? 3 : formData.type === "brand" ? 2 : 1;
          await propertyActions.store(formData);
          handleCloseDialog();
          handleGetPropertyList(true);
          cancel();
        } else {
          const { formData } = state;
          formData.fee.percent =
            formData.fee.percent !== ""
              ? parseFloat(formatDB(formData.fee.percent.replace("%", "")))
              : 0;
          formData.fee.amount =
            formData.fee.amount !== ""
              ? parseFloat(
                  formatDB(
                    formData.fee.amount.replace(
                      process.env.REACT_APP_CURRENCY_SYMBOL,
                      ""
                    )
                  )
                )
              : 0;
          formData.level =
            formData.type === "group" ? 3 : formData.type === "brand" ? 2 : 1;
          await propertyActions.put(formData, data.id);
          handleCloseDialog();
          handleUpdateData();
          handleGetPropertyList(true);
          cancel();
        }
      });
    }
  };

  const handleChange = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.value;
    setState({ formData });
  };

  const handleChangeParent = (event) => {
    const { formData } = state;
    formData["parent"][event.target.name] = event.target.value;
    setState({ formData });
  };

  const handleChangeFee = (event) => {
    const { formData } = state;
    formData["fee"][event.target.name] = event.target.value;
    setState({ formData });
  };

  const handleSelectFeeType = (event, newFeeType) => {
    if (newFeeType !== null) {
      handleChangeFee({ target: { name: "percent", value: "" } });
      handleChangeFee({ target: { name: "amount", value: "" } });
      setFeeType(newFeeType);
    }
  };

  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
    ],
  };

  const formats = ["bold", "italic", "underline", "list", "bullet"];

  const loadDataRelation = () => {
    setLoading(true);
    const parentName = data ? data?.parent?.name : "";
    Promise.all([asyncGetOptionsParent(parentName)]).then(() => {
      setLoading(false);
    });
  };

  React.useEffect(() => {
    // const arrCurrency = getCurrencySymbols();
    // setOptionsCurrency(
    //   arrCurrency.map((row) => ({
    //     value: row.code,
    //     name: `${row.code} (${row.symbol})`,
    //   }))
    // );
    loadDataRelation();
    if (data) {
      setState({
        formData: {
          about: data.about,
          address: data.address,
          email: data.email,
          currency: process.env.REACT_APP_CURRENCY_CODE,
          id: data.id,
          image_banner_url: data.image_banner_url,
          initial: data.initial,
          latitude: data.latitude,
          level: 1,
          logo: {
            square: data.logo.square,
            rectangle: data.logo.rectangle,
          },
          longitude: data.longitude,
          name: data.name,
          phone: data.phone,
          timezone: data.timezone,
          type: data.type,
          website_url: data.website_url,
          fee: {
            name: data.fee.name,
            percent:
              data.fee.percent > 0
                ? formatCurrency(
                    process.env.REACT_APP_CURRENCY_CODE,
                    data.fee.percent,
                    true
                  )
                : "",
            amount:
              data.fee.amount > 0
                ? formatCurrency(
                    process.env.REACT_APP_CURRENCY_CODE,
                    data.fee.amount,
                    true
                  )
                : "",
          },
          have_runner: data.have_runner,
          parent: {
            id:
              user?.operational?.level === 2
                ? user?.operational?.id
                : data.parent.id,
          },
        },
      });

      setFeeType(
        data.fee.percent > 0
          ? "percent"
          : data.fee.amount > 0
          ? "amount"
          : "percent"
      );
    }

    ValidatorForm.addValidationRule("isValidUrl", (value) => {
      let url = value.toLowerCase();
      if (url.substr(0, 8) === "https://" || url.substr(0, 7) === "http://") {
        return true;
      }

      return false;
    });

    return () => {
      ValidatorForm.removeValidationRule("isValidUrl");
    };
  }, [data]);

  return (
    <CustomizedDialogs
      disableBackdropClick
      maxWidth={width !== "xs" ? "md" : false}
      fullScreen={width === "xs"}
      title={props.title}
      scroll="body"
      open={openDialog}
      handleClose={handleCloseDialog}
    >
      <DialogContent classes={{ root: classes.content }} dividers>
        {loading && (
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </div>
        )}
        {!loading && (
          <ValidatorForm
            id="myform"
            onSubmit={(e) => {
              handleSubmit(e);
            }}
          >
            <Paper className={classes.root} style={{ boxShadow: "none" }}>
              <Grid container>
                <Typography
                  variant="subtitle1"
                  style={{ fontWeight: "bolder", fontSize: 18 }}
                  gutterBottom
                >
                  Property Details
                </Typography>
                <Grid item xs={12}>
                  <SelectValidator
                    id="type"
                    name="type"
                    label="Property Type"
                    className={classes.textField}
                    margin="normal"
                    value={state.formData.type}
                    validators={["required"]}
                    errorMessages={["Property Type is required"]}
                    onChange={handleChange}
                    autoFocus
                  >
                    {user?.operational?.level === 3 && (
                      <MenuItem value="brand">Brand</MenuItem>
                    )}
                    <MenuItem value="mall">Mall</MenuItem>
                    <MenuItem value="hotel">Hotel</MenuItem>
                    <MenuItem value="residential">Residential</MenuItem>
                  </SelectValidator>
                  {(state?.formData?.type === "mall" ||
                    state?.formData?.type === "hotel" ||
                    state?.formData?.type === "residential") &&
                    user?.operational?.level === 3 && (
                      <InputSelectSearch
                        value={state.formData.parent.id}
                        options={optionsParent}
                        getOptions={(query) => asyncGetOptionsParent(query)}
                        onChange={(value) =>
                          handleChangeParent({
                            target: { name: "id", value: value },
                          })
                        }
                        search
                        closeOnSelect={true}
                        placeholder="Search for Brand"
                      />
                    )}
                  <TextValidator
                    id="name"
                    label="Property Name"
                    name="name"
                    className={classes.textField}
                    margin="normal"
                    value={state.formData.name}
                    type="text"
                    inputProps={{ maxLength: 100 }}
                    helperText={
                      <span
                        style={{ textAlign: "right", display: "block" }}
                      >{`${state.formData.name.length}/100`}</span>
                    }
                    validators={["required", "maxStringLength:100"]}
                    errorMessages={[
                      "Name is required",
                      "maximum character is 100",
                    ]}
                    onChange={handleChange}
                  />
                  <TextValidator
                    id="initial"
                    label="Initial Name"
                    name="initial"
                    className={classes.textField}
                    margin="normal"
                    value={state.formData.initial}
                    type="text"
                    inputProps={{ maxLength: 20 }}
                    helperText={
                      <span
                        style={{ textAlign: "right", display: "block" }}
                      >{`${state.formData.initial.length}/20`}</span>
                    }
                    validators={["required", "maxStringLength:20"]}
                    errorMessages={[
                      "Initial is required",
                      "Maximum character is 20",
                    ]}
                    onChange={handleChange}
                  />
                  <TextValidator
                    id="about"
                    label="Add Description"
                    name="about"
                    className={classes.textField}
                    margin="normal"
                    value={state.formData.about}
                    type="text"
                    inputProps={{ maxLength: 500 }}
                    helperText={
                      <span
                        style={{ textAlign: "right", display: "block" }}
                      >{`${state.formData.about.length}/500`}</span>
                    }
                    validators={["required", "maxStringLength:500"]}
                    errorMessages={[
                      "Description is required",
                      "Maximum character is 500",
                    ]}
                    onChange={handleChange}
                    multiline
                  />
                  {(state?.formData?.type === "mall" ||
                    state?.formData?.type === "hotel" ||
                    state?.formData?.type === "residential") && (
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={state.formData.have_runner}
                          onChange={(e) =>
                            handleChange({
                              target: {
                                name: e.target.name,
                                value: e.target.checked,
                              },
                            })
                          }
                          name="have_runner"
                          color="primary"
                        />
                      }
                      label="Have Runner ?"
                    />
                  )}

                  {user?.operational?.level === 3 &&
                    (state?.formData?.type === "mall" ||
                      state?.formData?.type === "hotel" ||
                      state?.formData?.type === "residential") && (
                      <div style={{ margin: "25px 0" }}>
                        <Typography
                          variant="subtitle1"
                          style={{ fontWeight: "bolder", fontSize: 18 }}
                          gutterBottom
                        >
                          Fee Detail
                        </Typography>
                        <TextValidator
                          id="fee_name"
                          label="Custom Name"
                          name="fee_name"
                          className={classes.textField}
                          margin="normal"
                          value={state.formData.fee.name}
                          type="text"
                          inputProps={{ maxLength: 50 }}
                          validators={["maxStringLength:50"]}
                          helperText={
                            <span
                              style={{ textAlign: "right", display: "block" }}
                            >{`${state.formData.fee.name.length}/50`}</span>
                          }
                          errorMessages={["Maximum character is 50"]}
                          onChange={(e) =>
                            handleChangeFee({
                              target: { name: "name", value: e.target.value },
                            })
                          }
                        />
                        <Grid container>
                          <Grid item xs={4}>
                            <StyledToggleButtonGroup
                              value={feeType}
                              exclusive
                              onChange={handleSelectFeeType}
                              aria-label="Fee Type"
                            >
                              <StyledToggleButton
                                value="percent"
                                aria-label="Percent"
                              >
                                %
                              </StyledToggleButton>
                              <StyledToggleButton
                                value="amount"
                                aria-label="Amount"
                              >
                                Fixed Amount
                              </StyledToggleButton>
                            </StyledToggleButtonGroup>
                          </Grid>
                          <Grid item xs={8}>
                            {feeType === "percent" && (
                              <MaskedInput
                                mask={createMaskInput("", " %", true, 3)}
                                id="fee_percent-masked"
                                placeholder="Fee Percentage"
                                name="fee_percent"
                                onChange={(e) => {
                                  const { formData } = state;
                                  formData["fee"]["percent"] = e.target.value;
                                  setState({ formData });
                                }}
                                style={{ marginTop: 0 }}
                                render={(ref, props) => (
                                  <TextValidator
                                    inputRef={ref}
                                    {...props}
                                    value={state.formData.fee.percent}
                                    label="Fee Percentage"
                                    className={classes.textField}
                                    margin="normal"
                                    type="text"
                                    validators={["required"]}
                                    errorMessages={[
                                      "Fee Percentage is required",
                                    ]}
                                  />
                                )}
                              />
                            )}

                            {feeType === "amount" && (
                              <MaskedInput
                                mask={createMaskInput(
                                  process.env.REACT_APP_CURRENCY_SYMBOL + " ",
                                  "",
                                  false,
                                  null
                                )}
                                id="fee_amount-masked"
                                placeholder="Amount"
                                name="fee_amount"
                                onChange={(e) => {
                                  const { formData } = state;
                                  formData["fee"]["amount"] = e.target.value;
                                  setState({ formData });
                                }}
                                style={{ marginTop: 0 }}
                                render={(ref, props) => (
                                  <TextValidator
                                    inputRef={ref}
                                    {...props}
                                    value={state.formData.fee.amount}
                                    label="Amount"
                                    className={classes.textField}
                                    margin="normal"
                                    type="text"
                                    validators={["required"]}
                                    errorMessages={["Amount is required"]}
                                  />
                                )}
                              />
                            )}
                          </Grid>
                        </Grid>
                      </div>
                    )}

                  <Typography
                    variant="subtitle1"
                    style={{ fontWeight: "bolder", fontSize: 18 }}
                    gutterBottom
                  >
                    Contact
                  </Typography>
                  <TextValidator
                    id="email"
                    label="Email"
                    name="email"
                    className={classes.textField}
                    margin="normal"
                    value={state.formData.email}
                    type="text"
                    inputProps={{ maxLength: 100 }}
                    validators={["required", "maxStringLength:100"]}
                    errorMessages={[
                      "Email is required",
                      "Maximum character is 100",
                    ]}
                    onChange={handleChange}
                  />
                  <TextValidator
                    id="phone"
                    label="Customer Service Number (WA available)"
                    name="phone"
                    className={classes.textField}
                    margin="normal"
                    value={state.formData.phone}
                    type="text"
                    inputProps={{ maxLength: 100 }}
                    validators={[
                      "required",
                      "matchRegexp:08[1-9]{1}[1-9]{1}[0-9]{5,11}",
                    ]}
                    errorMessages={[
                      "Customer Service Number is required",
                      "Invalid format i.e (0818999999)",
                    ]}
                    onChange={handleChange}
                  />
                  <TextValidator
                    id="website_url"
                    label="Website URL"
                    name="website_url"
                    className={classes.textField}
                    margin="normal"
                    value={state.formData.website_url}
                    type="text"
                    inputProps={{ maxLength: 100 }}
                    validators={["maxStringLength:100", "isValidUrl"]}
                    errorMessages={[
                      "Maximum character is 100",
                      "Use http:// or https:// prefix",
                    ]}
                    onChange={handleChange}
                  />
                  <Typography
                    variant="subtitle1"
                    style={{
                      fontWeight: "bolder",
                      fontSize: 18,
                      marginTop: 16,
                    }}
                    gutterBottom
                  >
                    Address
                  </Typography>
                  <TextValidator
                    id="address"
                    label="Address"
                    name="address"
                    className={classes.textField}
                    margin="normal"
                    value={state.formData.address}
                    type="text"
                    inputProps={{ maxLength: 150 }}
                    validators={["required", "maxStringLength:150"]}
                    errorMessages={[
                      "Address is required",
                      "Maximum character is 150",
                    ]}
                    onChange={handleChange}
                  />
                  {(state?.formData?.type === "mall" ||
                    state?.formData?.type === "hotel" ||
                    state?.formData?.type === "residential") && (
                    <React.Fragment>
                      <Button
                        type="button"
                        variant="contained"
                        style={{
                          backgroundColor: "#EEEEEE",
                          color: "#757575",
                          fontSize: 13,
                          fontWeight: "600",
                          marginRight: 30,
                          borderRadius: 0,
                          boxShadow: "none",
                        }}
                        onClick={handleShowInstruction}
                      >
                        How to find a location's Latitude &amp; Longitude
                      </Button>
                      <Grid container>
                        <Grid item xs={6} style={{ paddingRight: "6px" }}>
                          <TextValidator
                            id="latitude"
                            label="Latitude"
                            name="latitude"
                            className={classes.textField}
                            margin="normal"
                            value={state.formData.latitude}
                            type="text"
                            inputProps={{ maxLength: 50 }}
                            validators={["required", "maxStringLength:50"]}
                            errorMessages={[
                              "Latitude is required",
                              "maximum character is 50",
                            ]}
                            onChange={handleChange}
                          />
                        </Grid>
                        <Grid item xs={6} style={{ paddingLeft: "6px" }}>
                          <TextValidator
                            id="longitude"
                            label="Longitude"
                            name="longitude"
                            className={classes.textField}
                            margin="normal"
                            value={state.formData.longitude}
                            type="text"
                            inputProps={{ maxLength: 50 }}
                            validators={["required", "maxStringLength:50"]}
                            errorMessages={[
                              "Longitude is required",
                              "maximum character is 50",
                            ]}
                            onChange={handleChange}
                          />
                        </Grid>
                      </Grid>
                      <SelectValidator
                        id="timezone"
                        name="timezone"
                        label="Select Timezone"
                        className={classes.textField}
                        margin="normal"
                        value={state.formData.timezone}
                        validators={["required"]}
                        errorMessages={["Timezone is required"]}
                        onChange={handleChange}
                      >
                        <MenuItem value="Asia/Jakarta">Asia/Jakarta</MenuItem>
                        <MenuItem value="Asia/Makassar">Asia/Makassar</MenuItem>
                        <MenuItem value="Asia/Jayapura">Asia/Jayapura</MenuItem>
                      </SelectValidator>
                    </React.Fragment>
                  )}
                  <Grid container>
                    <Grid item xs={12}>
                      <Typography
                        variant="subtitle1"
                        style={{
                          fontWeight: "bolder",
                          fontSize: 18,
                          marginTop: 16,
                        }}
                        gutterBottom
                      >
                        Graphic
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <Typography
                        variant="subtitle2"
                        style={{ fontSize: 13, fontWeight: "bolder" }}
                      >
                        Square Logo
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={9} md={9} lg={9}>
                      <InputImage
                        image={state.formData.logo.square}
                        maxSize={1000}
                        aspectW={1}
                        aspectH={1}
                        removeType="reset"
                        onUploadDone={(url) => {
                          const { formData } = state;
                          formData.logo.square = url;
                          setState({ formData });
                        }}
                        onRemove={(url) => {
                          const { formData } = state;
                          formData.logo.square = "";
                          setState({ formData });
                        }}
                        style={{
                          marginTop: "0px !important",
                          width: "100%",
                          height: 240,
                          maxWidth: "100%",
                          maxHeight: 240,
                        }}
                        styleWrapper={{
                          borderColor: "#BDBDBD",
                          borderRadius: 0,
                        }}
                        styleImage={{ height: 240, width: "auto" }}
                      />
                      <p
                        style={{
                          fontSize: 10,
                          color: "#757575",
                          lineHeight: 1,
                        }}
                      >
                        JPEG or 32-bit PNG
                        <br />
                        512 px by 512 px
                        <br />
                        Up to 1 MB
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <Typography
                        variant="subtitle2"
                        style={{ fontSize: 13, fontWeight: "bolder" }}
                      >
                        Rectangle Logo
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={9} md={9} lg={9}>
                      <InputImage
                        image={state.formData.logo.rectangle}
                        maxSize={1000}
                        aspectW={16}
                        aspectH={9}
                        removeType="reset"
                        onUploadDone={(url) => {
                          const { formData } = state;
                          formData.logo.rectangle = url;
                          setState({ formData });
                        }}
                        onRemove={(url) => {
                          const { formData } = state;
                          formData.logo.rectangle = "";
                          setState({ formData });
                        }}
                        style={{
                          marginTop: "0px !important",
                          width: "100%",
                          height: 240,
                          maxWidth: "100%",
                          maxHeight: 240,
                        }}
                        styleWrapper={{
                          borderColor: "#BDBDBD",
                          borderRadius: 0,
                        }}
                        styleImage={{ height: "auto", width: "100%" }}
                      />
                      <span style={{ fontSize: 10, color: "#757575" }}>
                        Shown at the top of your store listing and left
                        navigation dashboard
                      </span>
                      <p
                        style={{
                          fontSize: 10,
                          color: "#757575",
                          lineHeight: 1,
                        }}
                      >
                        JPEG or 32-bit PNG
                        <br />
                        510 px by 102 px
                        <br />
                        Up to 1 MB
                      </p>
                    </Grid>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <Typography
                        variant="subtitle2"
                        style={{ fontSize: 13, fontWeight: "bolder" }}
                      >
                        Property Banner
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={9} md={9} lg={9}>
                      <InputImage
                        image={state.formData.image_banner_url}
                        maxSize={1000}
                        aspectW={16}
                        aspectH={9}
                        removeType="reset"
                        onUploadDone={(url) => {
                          const { formData } = state;
                          formData.image_banner_url = url;
                          setState({ formData });
                        }}
                        onRemove={(url) => {
                          const { formData } = state;
                          formData.image_banner_url = "";
                          setState({ formData });
                        }}
                        style={{
                          marginTop: "0px !important",
                          width: "100%",
                          height: 240,
                          maxWidth: "100%",
                          maxHeight: 240,
                        }}
                        styleWrapper={{
                          borderColor: "#BDBDBD",
                          borderRadius: 0,
                        }}
                        styleImage={{ height: "auto", width: "100%" }}
                      />
                      <span style={{ fontSize: 10, color: "#757575" }}>
                        Shown at the top of your property listing{" "}
                      </span>
                      <p
                        style={{
                          fontSize: 10,
                          color: "#757575",
                          lineHeight: 1,
                        }}
                      >
                        JPEG or 32-bit PNG
                        <br />
                        1280 px by 720 px
                        <br />
                        16:9
                        <br />
                        Up to 1 MB
                      </p>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </ValidatorForm>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleCloseDialog();
          }}
          style={{
            color: "#BDBDBD",
            fontSize: 13,
            textTransform: "capitalize",
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          form="myform"
          variant="contained"
          style={{
            backgroundColor: "#2196F3",
            color: "#FFFFFF",
            fontSize: 13,
            marginRight: 30,
            borderRadius: 0,
            boxShadow: "none",
            textTransform: "capitalize",
          }}
        >
          Save
        </Button>
      </DialogActions>
    </CustomizedDialogs>
  );
}

Form.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
  handleGetPropertyList: PropTypes.func,
  handleUpdateData: PropTypes.func,
};
export function showForm(
  title,
  data,
  handleGetPropertyList,
  handleUpdateData,
  options = {}
) {
  return createConfirmation(confirmable(withStyles(styles)(withWidth()(Form))))(
    {
      title,
      data,
      handleGetPropertyList,
      handleUpdateData,
      ...options,
    }
  );
}
